import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["closeOptions", "ignoredClickOutsideRefs", "onClose", "className", "children", "style"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import React, { forwardRef } from 'react';
import { cnBem, combineRefs } from '@carnica/utils';
import { motion } from 'framer-motion';
import { IconCloseRoundStroked } from '@carnica/graphics';
import { ClickOutsideWrapper } from "../../ClickOutsideWrapper";
import { Button } from "../../../components/Button";
import styles from "../styles.pcss";
import { useSheetScroll } from "../hooks/useSheetScroll";
var cnBottomSheetWindow = cnBem('bottom-sheet', styles);
var varinats = {
  hidden: {
    poinerEvents: 'none',
    y: '100vh',
    opacity: 0
  },
  visible: {
    y: 0,
    opacity: 1,
    poinerEvents: 'all'
  }
};
export var BottomSheetWindow = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _objectSpread2;
  var closeOptions = _ref.closeOptions,
    ignoredClickOutsideRefs = _ref.ignoredClickOutsideRefs,
    onClose = _ref.onClose,
    className = _ref.className,
    children = _ref.children,
    style = _ref.style,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var _useSheetScroll = useSheetScroll(),
    scrollRef = _useSheetScroll.scrollRef,
    topOffset = _useSheetScroll.topOffset,
    radius = _useSheetScroll.radius;
  return /*#__PURE__*/React.createElement(ClickOutsideWrapper, {
    ignoreClicksInsideRefs: [].concat(_toConsumableArray(ignoredClickOutsideRefs), [scrollRef]),
    onClickOutside: closeOptions.overlay ? onClose : undefined,
    "data-t-id": "BottomSheet-BottomSheetWindow"
  }, /*#__PURE__*/React.createElement(motion.div, _extends({}, otherProps, {
    animate: "visible",
    className: cnBottomSheetWindow('container', [className]),
    exit: "hidden",
    initial: "hidden",
    ref: combineRefs([ref, scrollRef]),
    style: _objectSpread(_objectSpread({}, style), {}, (_objectSpread2 = {}, _defineProperty(_objectSpread2, '--bottom-sheet-offset', "".concat(topOffset, "px")), _defineProperty(_objectSpread2, '--bottom-sheet-radius', "".concat(radius, "px")), _objectSpread2)),
    transition: {
      transform: {
        duration: 0.3
      },
      opacity: {
        duration: 0.3
      }
    },
    variants: varinats
  }), closeOptions.button && /*#__PURE__*/React.createElement("div", {
    className: cnBottomSheetWindow('sticky-wrapper')
  }, /*#__PURE__*/React.createElement(Button, {
    "aria-label": "\u0417\u0430\u043A\u0440\u044B\u0442\u044C \u043C\u043E\u0434\u0430\u043B\u044C\u043D\u043E\u0435 \u043E\u043A\u043D\u043E",
    className: cnBottomSheetWindow('close'),
    iconLeft: IconCloseRoundStroked,
    onClick: onClose,
    onlyIcon: true,
    size: "m",
    type: "button",
    view: "secondary-on-primary"
  })), children));
});